import "babel-polyfill";
import "core-js/fn/object/assign";
import React from "react";
import ReactDOM from "react-dom";
import Root from "./Root.js";
import * as serviceWorker from "./serviceWorker";

// Render the main component into the dom
ReactDOM.render(<Root />, document.getElementById("app"));

serviceWorker.register();



// WEBPACK FOOTER //
// ./src/index.js